import React, { useEffect } from "react";
import { connect } from "react-redux";
import Preloader from "../components/Preloader/Preloader";
import "./scss/Home.scss";
import * as shopActions from "./../actions/shop";
import { bindActionCreators } from "redux";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import heroImage from "../images/home/hero2.webp";
import benefitLogistics from "../images/home/benefit-logistics.png";
import benefitHolland from "../images/home/benefit-holland.png";
import benefitPartner from "../images/home/benefit-partner.png";

import offerFlowers from "../images/home/offer-flowers.png";
import offerPlants from "../images/home/offer-plants.png";
import offerTools from "../images/home/offer-tools.png";
import offerSpecial from "../images/home/offer-special_en.png";

import howImage from "../images/home/how-it-works.png";

import partnerHamifleurs from "../images/home/partner-hamifleurs.png";
import partnerNaranjo from "../images/home/partner-naranjo.png";
import partnerRosaprima from "../images/home/partner-rosaprima.png";
import partnerIcon from "../images/home/partner-icon.png";

import logo from "../images/logo.png";

const Home = (props) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  document.title = `Gudema - ${t("home.pageTitle")}`;

  const { getContent, getGroups, changeReady } = props;

  useEffect(() => {
    getContent("home");
    getGroups();

    return () => {
      changeReady(false);
    };
  }, [getContent, getGroups, changeReady]);

  const getCurrentLangKey = () => {
  const lang = String(i18n.resolvedLanguage || i18n.language || "lt")
    .split("-")[0]
    .toLowerCase();

  if (lang === "fin" || lang === "fi") {
    return "FIN";
  }

  return lang.toUpperCase();
};

  const normalizeText = (value) =>
    String(value || "")
      .toLowerCase()
      .trim()
      .replaceAll("ū", "u")
      .replaceAll("ų", "u")
      .replaceAll("ė", "e")
      .replaceAll("ę", "e")
      .replaceAll("ą", "a")
      .replaceAll("č", "c")
      .replaceAll("š", "s")
      .replaceAll("ž", "z")
      .replaceAll("į", "i")
      .replaceAll("limai", "lymai");

      const getGroupsArray = () => {
        if (Array.isArray(props.groups)) {
          return props.groups;
        }

        if (Array.isArray(props.groups?.content)) {
          return props.groups.content;
        }

        if (Array.isArray(props.groups?.items)) {
          return props.groups.items;
        }

        return [];
      };

  const findGroupByName = (groupKey) => {
    const wanted = normalizeText(groupKey);

    return getGroupsArray().find((group) => {
      const names = group.names || {};

      return [group.name, names.LT, names.EN, names.RU, names.FIN].some(
        (name) => normalizeText(name) === wanted
      );
    });
  };

  const getGroupTitle = (groupKey) => {
    const group = findGroupByName(groupKey);
    const langKey = getCurrentLangKey();

    if (!group) {
      return groupKey;
    }

    return group.names?.[langKey] || group.names?.LT || group.name || groupKey;
  };

  const openOffer = (offer) => {
    if (!props.isAuth) {
      history.push("/login");
      return;
    }

    const group = findGroupByName(offer.groupKey);

    if (!group) {
      console.error("Group not found:", offer.groupKey, getGroupsArray());
      history.push("/shop");
      return;
    }

    props.resetFlowers();
    props.changeReady(false);

    props.setFilterParams({
      color: "",
      search: "",
      sort: "",
      groupId: group.id,
      page: 0,
      pageNumber: 0,
    });

    history.push("/shop");
  };

  if (!props.isReady) {
    return <Preloader />;
  }

  const benefits = [
    {
      icon: benefitLogistics,
      title: t("home.benefits.logistics.title"),
      text: t("home.benefits.logistics.text"),
    },
    {
      icon: benefitHolland,
      title: t("home.benefits.holland.title"),
      text: t("home.benefits.holland.text"),
    },
    {
      icon: benefitPartner,
      title: t("home.benefits.partner.title"),
      text: t("home.benefits.partner.text"),
    },
  ];

  const offers = [
    {
      image: offerFlowers,
      groupKey: "Skintos gėlės",
    },
    {
      image: offerPlants,
      groupKey: "Vazoniniai augalai",
    },
    {
      image: offerTools,
      groupKey: "Floristikos reikmenys",
    },
    {
      image: offerSpecial,
      groupKey: "Specialūs pasiūlymai",
    },
  ];

  const steps = [
    {
      title: t("home.process.step1Title"),
      text: t("home.process.step1Text"),
    },
    {
      title: t("home.process.step2Title"),
      text: t("home.process.step2Text"),
    },
    {
      title: t("home.process.step3Title"),
      text: t("home.process.step3Text"),
    },
    {
      title: t("home.process.step4Title"),
      text: t("home.process.step4Text"),
    },
  ];

  return (
    <main className="home-page">
      <section className="home-hero">
        <div className="home-hero__content">
          <h1>{t("home.title")}</h1>

          <p>{t("home.subtitle")}</p>

          <div className="home-hero__actions">
            <Link to="/about" className="home-btn home-btn--primary">
              {t("home.becomePartner")} &nbsp;
              <img src={partnerIcon} alt="" />
            </Link>

            <Link to="/login" className="home-btn home-btn--outline">
              {t("home.login")}
            </Link>
          </div>
        </div>

        <div className="home-hero__image">
          <img src={heroImage} alt={t("home.title")} />
        </div>
      </section>

      <section className="home-benefits">
        <h2>{t("home.whyChoose")}</h2>

        <div className="home-benefits__grid">
          {benefits.map((item) => (
            <article key={item.title} className="home-benefit">
              <div className="home-benefit__head">
                <img src={item.icon} alt="" />
                <h3>{item.title}</h3>
              </div>

              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="home-offer">
        <h2>{t("home.offer.title")}</h2>

        <p>{t("home.offer.text")}</p>

        <div className="home-offer__grid">
          {offers.map((item, i) => {
            const title = getGroupTitle(item.groupKey);

            return (
              <button
                type="button"
                className="home-offer-card"
                id={`home-offer-card-${i}`}
                key={item.groupKey}
                onClick={() => openOffer(item)}
              >
                <img src={item.image} alt={title} id={`card-image-${i}`} />
                <h3>{title}</h3>
              </button>
            );
          })}
        </div>

        <Link to="/shop" className="home-btn home-btn--outline home-offer__btn">
          {t("home.offer.all")}
        </Link>
      </section>

      <section className="home-process">
        <div className="home-process__inner">
          <div className="home-process__content">
            <h2>{t("home.process.title")}</h2>

            <div className="home-process__steps">
              {steps.map((item) => (
                <article key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="home-process__image">
            <img src={howImage} alt={t("home.process.title")} />
          </div>
        </div>

        <div className="home-cta">
          <div>
            <img className="home-cta__logo" src={logo} alt="Gudema" />

            <p>{t("home.cta.text")}</p>

            <Link to="/about#partner-form" className="home-btn home-btn--primary">
              {t("home.becomePartner")}
            </Link>
          </div>
        </div>

        <div className="home-partners">
          <span>{t("home.partners")}</span>

          <div>
            <img src={partnerHamifleurs} alt="Hamifleurs" />
            <img src={partnerNaranjo} alt="Naranjo" />
            <img src={partnerRosaprima} alt="Rosaprima" />
          </div>
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  content: state.shop.content,
  isReady: state.shop.isReady,
  isAuth: !!state.auth.authUsername,
  filterParams: state.shop.filterParams,
  groups: state.shop.groups,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(shopActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);